module.exports = __webpack_public_path__ + "908e4d2e/img/lock-icon.bb9c7166.svg";